module.exports = __webpack_public_path__ + "img/navbar2.4b41e7f6.png";